<template>
  <div v-if="payments.length" id="visit-payments-history">
    <hr class="dashed"/>
    <h3>{{ $t('payment_history') }}</h3>
<!--    <div v-if="visit.payments && visit.payments.length == 0">-->
<!--      {{ $t('there_were_no_payments') }}-->
<!--    </div>-->
    <div class="patient-visit-services-table patient-visit-services-table-card">
      <div class="row no-gutters font-weight-bold table-header">
        <div class="col-4 col-td">{{ $t('payment_date') }}</div>
        <div class="col-4 col-td">{{ $t('payment_form') }}</div>
        <div class="col-4 col-td">{{ $t('sum') }}</div>
      </div>

      <div class="table-row">
        <div class="row no-gutters"
             v-for="(p, pind) in payments"
             :key="`pay-row-${pind}`">
          <div class="col-4 col-td">{{ formatDateTime(p.date) }}</div>
          <div class="col-4 col-td">{{ $t(p.payment_type) }}</div>
          <div class="col-4 col-td">{{ formatCurrency(p.paid) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue"
import {useStore} from "vuex"
import {formatCurrency, formatDateTime} from "@/extensions/filters/filters"

const store = useStore()

const visit = computed(() => store.state.patient.visit)
const payments = computed(() => visit.value?.payments || [])
</script>
